module.exports = __webpack_public_path__ + "img/PONTAPOINT_200x120.57a2d159.png";